import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { showAddons } from "../../../network/network";
import { handleApiError } from "../../../utils/errorHandler";

const useAddons = ({
  reloadData,
  pendingActionReloadRef,
  setActionLoading,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [addonData, setAddonData] = useState([]);

  useEffect(() => {
    let isEffectActive = true;
    const keepActionLoading = pendingActionReloadRef.current;

    if (!keepActionLoading) {
      setLoading(true);
    }

    showAddons()
      .then((response) => {
        if (!isEffectActive) return;

        if (response?.data?.success === false) {
          handleApiError(response, t);
          return;
        }

        setAddonData(response?.data?.data?.addons || []);
      })
      .catch((error) => {
        if (isEffectActive) handleApiError(error, t);
      })
      .finally(() => {
        if (isEffectActive) {
          setLoading(false);

          if (pendingActionReloadRef.current) {
            setActionLoading(false);
            pendingActionReloadRef.current = false;
          }
        }
      });

    return () => {
      isEffectActive = false;
    };
  }, [reloadData, t, pendingActionReloadRef, setActionLoading]);

  return { loading, addonData };
};

export default useAddons;
